import "./Home.css"
import data from "./data"
import moredark1 from "../../assets/moredark1.png"
import { TypeAnimation } from 'react-type-animation';

const Home = () => {
  return (

<header id="header">
  <div className="container header_container">
    <div className="header_profile">
      <img src={moredark1} alt="header portrait" />
    </div>
    <h2>Ashmit Yadav</h2>
    <TypeAnimation
                // Same String at the start will only be typed once, initially
              sequence={[
              'Full Stack Web Developer.',
              1000,
              'MERN Stack Web Developer.',
              1000,
              'A Tech Enthusiast.',
              1000,
              
              ]}
              speed={50} // Custom Speed from 1-99 - Default Speed: 40
              
               style={{ fontSize: "30px", textAlign:"initial",color: "--color-primary"}}
              wrapper="span" // Animation will be rendered as a <span>
              repeat={Infinity} // Repeat this Animation Sequence infinitely
            />
    <div className="header_cta">
      <a href="#contact" className="btn primary">let's talk</a>
      <a href="#portfolio" className="btn light"> My work</a>
    </div>

    <div className="header_socials">
      {
        data.map(item=> <a key={item.id} href={item.link} target="_blank"
        rel="noopener noreferrer">{item.icon}</a>)
      }

    </div>

  </div>

</header>
  )
}

export default Home